import React from 'react';

function Footer() {
  return (
    <footer className="tm-footer">
      <div className="tm-container">
        <p>© 2025 Maximo Augusto Paulucci. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
}

export default Footer;


